<template>
  <div class="d-flex align-center">
    <div
      v-for="(language, index) in langs"
      :key="language"
      class="lang-container"
      :class="{
        'mr-0': index == langsCount - 1,
        'mr-2': index != langsCount - 1,
        'lang--chosen': nodeLang == language
      }"
      @click="changeLang(language)"
    >
      <div
        class="lang-icon"
        :style="`background-image: url(${baseUrl}img/lang-${language}.svg);`"
      />
    </div>
  </div>
</template>
<script>
import Repository from "@/api/profile";
export default {
  props: {
    langs: {
      type: Array,
      required: true
    },
    lang: {
      type: String,
      default: ""
    }
  },
  computed: {
    langsCount() {
      return this.langs.length;
    },
    nodeLang() {
      return this.lang == "" ? this.$store.getters.getLang : this.lang;
    },
    baseUrl() {
      return process.env.BASE_URL;
    }
  },
  methods: {
    async changeLang(lang) {
      this.$emit("before-change-lang", lang);
      this.$store.commit("setLang", lang);
      await Repository.setLang(lang);
      this.$emit("change-lang", lang);
    }
  }
};
</script>
<style lang="scss" scoped>
.lang-container {
  position: relative;
  cursor: pointer;
  display: inline-block;

  .lang-icon {
    width: 24px;
    height: 24px;
    background-size: 22px;
    border-radius: 24px;
    background-position: center;
    border: 2px solid #d8e0e6;

    .header--dark & {
      border: 2px solid #454a51;
    }
  }

  .lang-icon__fader {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 24px;
    background-color: rgba(255, 255, 255, 0.8);

    .header--dark & {
      background-color: #2e323a;
      opacity: 0.8;
    }
  }

  &.lang--chosen {
    cursor: inherit;

    .lang-icon {
      border: 2px solid #2196f3;
    }
  }

  &.lang--disabled {
    cursor: inherit;

    .lang-icon__fader {
      display: block;
    }
  }
}
</style>
